import { Result } from '../core';
import { Error, error } from '../core/error';
import { ApiError } from './apiError';

export function getApiResultJobError(result: Result[]): Error | null {
  const unpublishedErr = result.some(res => res[1]?.message === 'Unauthorized - UNPUBLISHED');
  if (unpublishedErr)
    return error('JobUnavailable');

  const unauthorizedErr = result.some(res => res[1]?.message === 'Unauthorized');
  if (unauthorizedErr)
    return error('JobUnauthorized');

  const deletedErr = result.some(res => res[1]?.message?.indexOf('Job is deleted') === 0);
  if (deletedErr)
    return error('JobDeleted');

  const unknownErr = result.some(res => !!res[1]);
  if (unknownErr)
    return error('Unknown', result[0][1]?.message);

  return null;
}

export function getApiTeamError(apiError: ApiError | null): Error {
  if (!apiError) return error('Unknown');

  if (apiError.message.includes('Team is deleted'))
    return error('TeamDeleted');

  if (apiError.message.includes('Unauthorized'))
    return error('Unauthorized');

  // The backend answers 'Not Found' for libraries the caller can't see, so the
  // page can't tell a denied library from a missing one.
  if (apiError.message.includes('Not Found'))
    return error('NotFound');

  // Invitations are accepted only from a verified email; the backend's message says what to do.
  if (apiError.message.includes('Verify your email'))
    return error('Unknown', apiError.message);

  // TODO: treat other error cases
  return error('Unknown');
}

/** The backend refuses agency data a caller can no longer see with `Unauthorized` or `Not Found`. */
export function isAgencyAccessRefused(apiError: Error | null | undefined): boolean {
  const message = apiError?.message ?? '';
  return message.includes('Unauthorized') || message.includes('Not Found');
}

export function apiResultIsAborted(result: Result<unknown, ApiError>): boolean {
  return result[1]?.type === 'RequestAborted';
}

export function batchApiResultIsAborted(result: Result<unknown, ApiError>[]): boolean {
  return result.some(res => apiResultIsAborted(res));
}